import axios from "axios";
import {
  EMPLOYEE_LIST_REQUEST,
  EMPLOYEE_LIST_SUCCESS,
  EMPLOYEE_LIST_FAIL,
  EMPLOYEE_LIST_SIMPLE_REQUEST,
  EMPLOYEE_LIST_SIMPLE_SUCCESS,
  EMPLOYEE_LIST_SIMPLE_FAIL,
  EMPLOYEE_CREATE_REQUEST,
  EMPLOYEE_CREATE_SUCCESS,
  EMPLOYEE_CREATE_FAIL,
  EMPLOYEE_DELETE_REQUEST,
  EMPLOYEE_DELETE_SUCCESS,
  EMPLOYEE_DELETE_FAIL,
  EMPLOYEE_DETAILS_REQUEST,
  EMPLOYEE_DETAILS_SUCCESS,
  EMPLOYEE_DETAILS_FAIL,
  EMPLOYEE_UPDATE_REQUEST,
  EMPLOYEE_UPDATE_SUCCESS,
  EMPLOYEE_UPDATE_FAIL,
  EMPLOYEE_UPDATE_STATUS_REQUEST,
  EMPLOYEE_UPDATE_STATUS_SUCCESS,
  EMPLOYEE_UPDATE_STATUS_FAIL,
  EMPLOYEE_UPDATE_STATUS_RESET,
  EMPLOYEE_WORK_SCHEDULE_REQUEST,
  EMPLOYEE_WORK_SCHEDULE_SUCCESS,
  EMPLOYEE_WORK_SCHEDULE_FAIL,
  EMPLOYEE_WORK_SCHEDULE_RESET,
  EMPLOYEE_WORK_SCHEDULE_UPDATE_REQUEST,
  EMPLOYEE_WORK_SCHEDULE_UPDATE_SUCCESS,
  EMPLOYEE_WORK_SCHEDULE_UPDATE_FAIL,
  EMPLOYEE_WORK_SCHEDULE_UPDATE_RESET,
  EMPLOYEE_DOCUMENT_UPLOAD_REQUEST,
  EMPLOYEE_DOCUMENT_UPLOAD_SUCCESS,
  EMPLOYEE_DOCUMENT_UPLOAD_FAIL,
  EMPLOYEE_DOCUMENT_UPLOAD_RESET,
  EMPLOYEE_DOCUMENT_DELETE_REQUEST,
  EMPLOYEE_DOCUMENT_DELETE_SUCCESS,
  EMPLOYEE_DOCUMENT_DELETE_FAIL,
  EMPLOYEE_DOCUMENT_DELETE_RESET,
} from "../constants/employeeConstants";
import { listTenantDetailsBySlugAction } from "./tenantActions";

// import { logout } from "./userActions";

export const listEmployeesAction =
  (
    slug,
    searchTerm = "",
    page = 1,
    pageSize = 10,
    sortField = "",
    sortOrder = "",
    status = "",
    startDate = "",
    endDate = "",
    profession = ""
  ) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: EMPLOYEE_LIST_REQUEST,
      });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      // Constructing the query string
      let query = `/api/${slug}/employees?`; // Using `slug` only once in the URL
      query += `searchTerm=${encodeURIComponent(searchTerm)}`;
      query += `&pageNumber=${page}`;
      query += `&pageSize=${pageSize}`;
      if (sortField) query += `&sortField=${sortField}`;
      if (sortOrder) query += `&sortOrder=${sortOrder}`;

      if (status) query += `&status=${encodeURIComponent(status)}`;
      if (startDate) query += `&startDate=${encodeURIComponent(startDate)}`;
      if (endDate) query += `&endDate=${encodeURIComponent(endDate)}`;
      if (profession) query += `&profession=${encodeURIComponent(profession)}`;

      // console.log("listUsersEmployees query", query);

      const { data } = await axios.get(query, config);

      // console.log("listUsersEmployees data", data);

      dispatch({
        type: EMPLOYEE_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: EMPLOYEE_LIST_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const listEmployeesAllSimple = (slug) => async (dispatch, getState) => {
  try {
    dispatch({ type: EMPLOYEE_LIST_SIMPLE_REQUEST });

    const {
      authLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        // 'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(
      `/api/${slug}/employees/all-simple`,
      config
    );

    dispatch({
      type: EMPLOYEE_LIST_SIMPLE_SUCCESS,
      payload: data,
    });

    // console.log("ACTION DATA listAllUsersEmployeesSimple", data);

    // console.log("listAllUsersEmployeesSimple data", data);
  } catch (error) {
    dispatch({
      type: EMPLOYEE_LIST_SIMPLE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const createEmployeeAction =
  (slug, employee) => async (dispatch, getState) => {
    try {
      dispatch({
        type: EMPLOYEE_CREATE_REQUEST,
      });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.post(
        `/api/${slug}/employees/create`,
        employee,
        config
      );

      dispatch({
        type: EMPLOYEE_CREATE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: EMPLOYEE_CREATE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const deleteEmployeeAction =
  (slug, id) => async (dispatch, getState) => {
    try {
      dispatch({
        type: EMPLOYEE_DELETE_REQUEST,
      });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      await axios.delete(`/api/${slug}/employees/${id}/delete`, config);

      dispatch({
        type: EMPLOYEE_DELETE_SUCCESS,
      });

      dispatch(listTenantDetailsBySlugAction(slug));
    } catch (error) {
      dispatch({
        type: EMPLOYEE_DELETE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const getEmployeeDetailsAction =
  (slug, id) => async (dispatch, getState) => {
    try {
      dispatch({
        type: EMPLOYEE_DETAILS_REQUEST,
      });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.get(`/api/${slug}/employees/${id}`, config);

      dispatch({
        type: EMPLOYEE_DETAILS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: EMPLOYEE_DETAILS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const updateEmployeeAction =
  (slug, id, employee) => async (dispatch, getState) => {
    try {
      dispatch({ type: EMPLOYEE_UPDATE_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `/api/${slug}/employees/${id}`,
        employee,
        config
      );

      dispatch({
        type: EMPLOYEE_UPDATE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: EMPLOYEE_UPDATE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const updateEmployeeStatusAction =
  (slug, id, status) => async (dispatch, getState) => {
    try {
      dispatch({ type: EMPLOYEE_UPDATE_STATUS_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `/api/${slug}/employees/${id}/status`,
        { status },
        config
      );

      dispatch({
        type: EMPLOYEE_UPDATE_STATUS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: EMPLOYEE_UPDATE_STATUS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const getEmployeeWorkScheduleAction =
  (slug, employeeId) => async (dispatch, getState) => {
    try {
      dispatch({ type: EMPLOYEE_WORK_SCHEDULE_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.get(
        `/api/${slug}/employees/${employeeId}/work-schedule`,
        config
      );

      dispatch({
        type: EMPLOYEE_WORK_SCHEDULE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: EMPLOYEE_WORK_SCHEDULE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const updateEmployeeWorkScheduleAction =
  (slug, employeeId, workSchedule) => async (dispatch, getState) => {
    try {
      dispatch({ type: EMPLOYEE_WORK_SCHEDULE_UPDATE_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `/api/${slug}/employees/${employeeId}/work-schedule`,
        { workSchedule },
        config
      );

      dispatch({
        type: EMPLOYEE_WORK_SCHEDULE_UPDATE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: EMPLOYEE_WORK_SCHEDULE_UPDATE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const uploadEmployeeDocumentAction =
  (slug, employeeId, file) => async (dispatch, getState) => {
    try {
      dispatch({ type: EMPLOYEE_DOCUMENT_UPLOAD_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const formData = new FormData();
      formData.append("file", file);

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.post(
        `/api/${slug}/employees/${employeeId}/documents`,
        formData,
        config
      );

      dispatch({
        type: EMPLOYEE_DOCUMENT_UPLOAD_SUCCESS,
        payload: data.document,
      });
    } catch (error) {
      dispatch({
        type: EMPLOYEE_DOCUMENT_UPLOAD_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const deleteEmployeeDocumentAction =
  (slug, employeeId, documentId) => async (dispatch, getState) => {
    try {
      dispatch({ type: EMPLOYEE_DOCUMENT_DELETE_REQUEST });

      const {
        authLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      await axios.delete(
        `/api/${slug}/employees/${employeeId}/documents/${documentId}`,
        config
      );

      dispatch({
        type: EMPLOYEE_DOCUMENT_DELETE_SUCCESS,
        payload: documentId,
      });
    } catch (error) {
      dispatch({
        type: EMPLOYEE_DOCUMENT_DELETE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };
